import statusTypes from '@/enum/statusTypes'
import { Extension } from '@/types/extension'

export const extensionColor = (extension: Extension) => {
    if (!extension) {
        return { color: 'white' }
    }
    const data = statusTypes[extension.representativeStatus] || { color: 'white' }

    return data.color
}
